import { useGLTF } from "@react-three/drei";
import React from "react";
import useTextureCustom from "../../utils/customHooks/useTextureCustom";

export function LockMechanical({ position, visible, material, scale }) {
  const { nodes } = useGLTF("models/lock_mechanical.glb");
  return (
    <group position={position} dispose={null} visible={visible} scale={scale}>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.lock_mechanical.geometry}
        material={material}
      />
    </group>
  );
}

export function LockMechanicalLarge({ position, visible, material, decalOuterColor, scale }) {
  const { nodes, materials } = useGLTF("models/lock_mechanical_large.glb");

  materials.mechanical_lock_large_decal.color.set("white")//decalOuterColor);

  return (
    <group position={position} dispose={null} visible={visible} scale={scale}>
    <mesh
      castShadow
      receiveShadow
      geometry={nodes.lock_mechanical_large_1.geometry}
      material={material}
    />
    <mesh
      castShadow
      receiveShadow
      geometry={nodes.lock_mechanical_large_2.geometry}
      material={materials.mechanical_lock_large_decal_base}
    />
    <mesh
      castShadow
      receiveShadow
      geometry={nodes.lock_mechanical_large_3.geometry}
      material={materials.mechanical_lock_large_decal}
    />
    </group>
  );
}

export function LockSecuramToplit({ position, visible, material, scale }) {
  const { nodes, materials } = useGLTF("models/lock_securamtoplit.glb");
  useTextureCustom(materials.securam_toplit_dialpad, "Lock_securam_toplit_dialpad");
  return (
    <group position={position} dispose={null} visible={visible} scale={scale}>
        <mesh
          castShadow
          geometry={nodes.lock_securam_toplit_1.geometry}
          material={material}
        />
        <mesh
          castShadow
          geometry={nodes.lock_securam_toplit_2.geometry}
          material={materials.securam_toplit_dialpad}
        />
    </group>
  );
}

export function LockSecuramBacklit({ position, visible, material, scale }) {
  const { nodes, materials } = useGLTF("models/lock_securambacklit.glb");
  useTextureCustom(materials.securam_toplit_dialpad, "Lock_securam_toplit_dialpad");
  return (
    <group position={position} dispose={null} visible={visible} scale={scale}>
        <mesh
          castShadow
          geometry={nodes.lock_securam_backlit_1.geometry}
          material={material}
        />
        <mesh
          castShadow
          geometry={nodes.lock_securam_backlit_2.geometry}
          material={materials.securam_backlit_dialpad}
        />
    </group>
  );
}

export function LockSecuramProLogic({ position, visible, material, scale }) {
  const { nodes, materials } = useGLTF("models/lock_securamprologic.glb");
  useTextureCustom(materials.securam_prologic, "Lock_securam_prologic");
  return (
    <group position={position} dispose={null} visible={visible} scale={scale}>
        <mesh
          castShadow
          geometry={nodes.lock_securam_prologic_1.geometry}
          material={materials.securam_prologic}
        />
        <mesh
          castShadow
          geometry={nodes.lock_securam_prologic_2.geometry}
          material={material}
        />
    </group>
  );
}

//useGLTF.preload("models/lock_mechanical.glb");
//useGLTF.preload("models/lock_mechanical_large.glb");
//useGLTF.preload("models/lock_securamtoplit.glb");
//useGLTF.preload("models/lock_securambacklit.glb");
//useGLTF.preload("models/lock_securamprologic.glb");
